import { AuthorizationError, CompressionError, CryptoError, DirExistsError, ExternalFileTypeMismatchError, FileExistsError, FileSizeMismatchError, InvalidArgumentError, InvalidFileIdError, InvalidKeyError, InvalidPathError, InvalidStateError, IsDirError, NotDirError, NotEnoughDiskSpaceError, NotLinkError, SettingValidationError, UnknownError, UserError, } from '#common/types';
import { DataStoreAlreadyExistsError, DataStoreHasLinkedFilesError, DataStoreInvalidTypeError, DataStoreNotFoundError, DataStoreNotProvidedError, DataStoresError, } from '#external-files/types';
import { FilespaceVersionError } from '#filespace/types';
import { DirNotEmptyError, HardLinkTargetNotSupportedError } from '#filesystem/types';
export var WasmErrorType;
(function (WasmErrorType) {
    WasmErrorType["INVALID_PATH_EXCEPTION"] = "InvalidPathException";
    WasmErrorType["INVALID_FILE_ID_EXCEPTION"] = "InvalidFileIdException";
    WasmErrorType["INVALID_KEY_EXCEPTION"] = "InvalidKeyException";
    WasmErrorType["INVALID_ARGUMENT_EXCEPTION"] = "InvalidArgumentException";
    WasmErrorType["SETTING_VALIDATION_EXCEPTION"] = "SettingValidationFailedException";
    WasmErrorType["INVALID_STATE_EXCEPTION"] = "InvalidStateException";
    WasmErrorType["USER_EXCEPTION"] = "UserException";
    WasmErrorType["CRYPTO_EXCEPTION"] = "CryptoException";
    WasmErrorType["COMPRESSION_EXCEPTION"] = "CompressionException";
    WasmErrorType["AUTHORIZATION_EXCEPTION"] = "AuthorizationException";
    WasmErrorType["DIR_EXISTS_EXCEPTION"] = "DirExistsException";
    WasmErrorType["FILE_EXISTS_EXCEPTION"] = "FileExistsException";
    WasmErrorType["DIR_NOT_EMPTY_EXCEPTION"] = "DirNotEmptyException";
    WasmErrorType["NOT_DIR_EXCEPTION"] = "NotDirException";
    WasmErrorType["IS_DIR_EXCEPTION"] = "IsDirException";
    WasmErrorType["NOT_LINK_EXCEPTION"] = "NotLinkException";
    WasmErrorType["HARD_LINK_TARGET_NOT_SUPPORTED_EXCEPTION"] = "HardLinkTargetNotSupportedException";
    WasmErrorType["EXTERNAL_FILE_TYPE_MISMATCH_EXCEPTION"] = "ExternalFileTypeMismatchException";
    WasmErrorType["FILE_SIZE_MISMATCH_EXCEPTION"] = "FileSizeMismatchException";
    WasmErrorType["NOT_ENOUGH_DISK_SPACE_EXCEPTION"] = "NotEnoughDiskSpaceException";
    WasmErrorType["DATA_STORE_NOT_FOUND_EXCEPTION"] = "DataStoreNotFoundException";
    WasmErrorType["DATA_STORE_ALREADY_EXISTS_EXCEPTION"] = "DataStoreAlreadyExistsException";
    WasmErrorType["DATA_STORE_HAS_LINKED_FILES_EXCEPTION"] = "DataStoreHasLinkedFilesException";
    WasmErrorType["DATA_STORE_NOT_PROVIDED_EXCEPTION"] = "DataStoreNotProvidedException";
    WasmErrorType["DATA_STORE_INVALID_TYPE_EXCEPTION"] = "DataStoreInvalidTypeException";
    WasmErrorType["DATA_STORES_EXCEPTION"] = "DataStoresException";
    WasmErrorType["FILESPACE_VERSION_EXCEPTION"] = "FilespaceVersionException";
    WasmErrorType["UNSUPPORTED_LAYOUT_FEATURE_EXCEPTION"] = "UnsupportedLayoutFeatureException";
})(WasmErrorType || (WasmErrorType = {}));
export function parseWasmResult(result) {
    const jsErr = result.jsError;
    if (jsErr) {
        throw jsErr;
    }
    const wasmErr = result.wasmError;
    if (wasmErr) {
        throwWasmError(wasmErr);
    }
    return result.value;
}
function throwWasmError(wasmErr) {
    const message = wasmErr.message;
    const devDetails = wasmErr.devDetails;
    switch (wasmErr.type) {
        case WasmErrorType.INVALID_PATH_EXCEPTION:
            throw new InvalidPathError(message, devDetails);
        case WasmErrorType.INVALID_FILE_ID_EXCEPTION:
            throw new InvalidFileIdError(message, devDetails);
        case WasmErrorType.INVALID_KEY_EXCEPTION:
            throw new InvalidKeyError(message, devDetails);
        case WasmErrorType.INVALID_ARGUMENT_EXCEPTION:
            throw new InvalidArgumentError(message, devDetails);
        case WasmErrorType.INVALID_STATE_EXCEPTION:
            throw new InvalidStateError(message, devDetails);
        case WasmErrorType.USER_EXCEPTION:
            throw new UserError(message, devDetails);
        case WasmErrorType.CRYPTO_EXCEPTION:
            throw new CryptoError(message, devDetails);
        case WasmErrorType.COMPRESSION_EXCEPTION:
            throw new CompressionError(message, devDetails);
        case WasmErrorType.AUTHORIZATION_EXCEPTION:
            throw new AuthorizationError(message, devDetails);
        case WasmErrorType.DIR_EXISTS_EXCEPTION:
            throw new DirExistsError(message, devDetails);
        case WasmErrorType.FILE_EXISTS_EXCEPTION:
            throw new FileExistsError(message, devDetails);
        case WasmErrorType.DIR_NOT_EMPTY_EXCEPTION:
            throw new DirNotEmptyError(message, devDetails);
        case WasmErrorType.NOT_DIR_EXCEPTION:
            throw new NotDirError(message, devDetails);
        case WasmErrorType.IS_DIR_EXCEPTION:
            throw new IsDirError(message, devDetails);
        case WasmErrorType.NOT_LINK_EXCEPTION:
            throw new NotLinkError(message, devDetails);
        case WasmErrorType.HARD_LINK_TARGET_NOT_SUPPORTED_EXCEPTION:
            throw new HardLinkTargetNotSupportedError(message, devDetails);
        case WasmErrorType.EXTERNAL_FILE_TYPE_MISMATCH_EXCEPTION:
            throw new ExternalFileTypeMismatchError(message, devDetails);
        case WasmErrorType.FILE_SIZE_MISMATCH_EXCEPTION:
            throw new FileSizeMismatchError(message, devDetails);
        case WasmErrorType.NOT_ENOUGH_DISK_SPACE_EXCEPTION:
            throw new NotEnoughDiskSpaceError(message, devDetails);
        case WasmErrorType.SETTING_VALIDATION_EXCEPTION:
            throw new SettingValidationError(message, devDetails);
        case WasmErrorType.DATA_STORE_NOT_FOUND_EXCEPTION:
            throw new DataStoreNotFoundError(message, devDetails);
        case WasmErrorType.DATA_STORE_ALREADY_EXISTS_EXCEPTION:
            throw new DataStoreAlreadyExistsError(message, devDetails);
        case WasmErrorType.DATA_STORE_HAS_LINKED_FILES_EXCEPTION:
            throw new DataStoreHasLinkedFilesError(message, devDetails);
        case WasmErrorType.DATA_STORE_NOT_PROVIDED_EXCEPTION:
            throw new DataStoreNotProvidedError(message, devDetails);
        case WasmErrorType.DATA_STORE_INVALID_TYPE_EXCEPTION:
            throw new DataStoreInvalidTypeError(message, devDetails);
        case WasmErrorType.DATA_STORES_EXCEPTION:
            throw new DataStoresError(message, devDetails);
        case WasmErrorType.FILESPACE_VERSION_EXCEPTION:
        case WasmErrorType.UNSUPPORTED_LAYOUT_FEATURE_EXCEPTION:
            throw new FilespaceVersionError(message, devDetails);
        default:
            throw new UnknownError(`Unexpected WASM error: ${message}`);
    }
}
